<template>
  <b-card>
    <!-- about -->
    <div>
      <h5 class="text-capitalize mb-75">name</h5>
      <b-card-text>
        {{ eduProgram.name }}
      </b-card-text>
    </div>
  </b-card>
</template>

<script>
import { BCard, BCardText } from "bootstrap-vue";

export default {
  components: {
    BCard,
    BCardText,
  },
  data() {
    return {
      profileData: {},
    };
  },
  created() {
    let id = localStorage.getItem("eduProgram");
    this.eduProgram = Auth.EDU_PROGRAMS.find((a) => a.id == id);
    console.log(this.eduProgram);
  },
};
</script>
